<p-dialog [header]="'SDS_BULK_IMPORT' | translate" [visible]="visible"
  (visibleChange)="close()" [modal]="true" [closable]="!importing"
  [closeOnEscape]="!importing" [draggable]="false" [resizable]="false"
  [style]="{ width: '680px', maxWidth: '96vw' }">
  <p>{{ 'SDS_BULK_HELP' | translate }}</p>
  <p class="text-muted">{{ 'SDS_BULK_LIMITS' | translate }}</p>
  <input #localFiles type="file" multiple accept=".pdf,application/pdf" hidden (change)="selectLocal($event)" />
  <div class="d-flex flex-wrap mb-3" style="gap: 0.5rem">
    <button type="button" class="btn btn-outline-primary" [disabled]="importing" (click)="localFiles.click()">
      <i class="pi pi-upload" aria-hidden="true"></i> {{ 'SDS_BULK_LOCAL' | translate }}
    </button>
    <button type="button" class="btn btn-outline-primary" [disabled]="importing" (click)="archiveVisible = true">
      <i class="pi pi-folder" aria-hidden="true"></i> {{ 'SDS_BULK_ARCHIVE' | translate }}
    </button>
  </div>
  <ul class="list-group mb-3">
    <li *ngFor="let file of files; let i = index" class="list-group-item d-flex align-items-center justify-content-between">
      <span class="text-break">{{ file.name }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="importing"
        (click)="files.splice(i, 1)" [attr.aria-label]="('REMOVE' | translate) + ' ' + file.name"><i class="pi pi-times" aria-hidden="true"></i></button>
    </li>
    <li *ngFor="let file of archiveFiles; let i = index" class="list-group-item d-flex align-items-center justify-content-between">
      <span class="text-break">{{ file.name }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="importing"
        (click)="archiveFiles.splice(i, 1)" [attr.aria-label]="('REMOVE' | translate) + ' ' + file.name"><i class="pi pi-times" aria-hidden="true"></i></button>
    </li>
  </ul>
  <p *ngIf="errorKey" class="text-danger" role="alert">{{ errorKey | translate }}</p>
  <p *ngIf="importing" role="status"><i class="pi pi-spin pi-spinner" aria-hidden="true"></i> {{ 'SDS_BULK_IMPORTING' | translate }}</p>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-secondary" [disabled]="importing" (click)="close()">{{ 'CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" [disabled]="importing || count === 0" (click)="importFiles()">
      {{ 'SDS_BULK_IMPORT' | translate }} ({{ count }})
    </button>
  </ng-template>
</p-dialog>
<app-sds-archive-picker [businessId]="businessId" [(visible)]="archiveVisible"
  [multiple]="true" (filesSelected)="selectArchive($event)"></app-sds-archive-picker>
